import { dashboardApi, DashboardApiTypes } from 'api'
import { useApiRequest } from 'hooks/useApiRequest'
import { useEffect, useState } from 'react'
import { format } from 'date-fns'
import { STOP_SALES_DATE_FORMAT } from 'constants/date'

export const useGeneralData = (
  companyId: string | number,
  selectedRange: { from: string; to: string },
  carCategories?: string[]
) => {
  const [volumesData, setVolumesData] =
    useState<DashboardApiTypes.VolumesResponse>()
  const [revenueData, setRevenueData] =
    useState<DashboardApiTypes.RevenueResponse>()

  const getVolumesRequest = useApiRequest(
    (companyId, dateStart, dateEnd, carCategories) =>
      dashboardApi.getVolumes({
        companyId: String(companyId),
        dateStart,
        dateEnd,
        carCategories,
      })
  )

  const getRevenueRequest = useApiRequest(
    (companyId, dateStart, dateEnd, carCategories) =>
      dashboardApi.getRevenue({
        companyId: String(companyId),
        dateStart,
        dateEnd,
        carCategories,
      })
  )

  useEffect(() => {
    if (selectedRange.from && selectedRange.to && companyId) {
      const getVolumes = async () => {
        const [volumes, revenue] = await Promise.all([
          getVolumesRequest.apiRequest(
            companyId,
            format(new Date(selectedRange.from), STOP_SALES_DATE_FORMAT),
            format(new Date(selectedRange.to), STOP_SALES_DATE_FORMAT),
            carCategories
          ),
          getRevenueRequest.apiRequest(
            companyId,
            format(new Date(selectedRange.from), STOP_SALES_DATE_FORMAT),
            format(new Date(selectedRange.to), STOP_SALES_DATE_FORMAT),
            carCategories
          ),
        ])
        if (volumes && revenue) {
          setVolumesData(volumes.data)
          setRevenueData(revenue.data)
        }
      }
      getVolumes()
    }
  }, [companyId, selectedRange.from, selectedRange.to, carCategories])

  return {
    volumesData,
    revenueData,
  }
}
